import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import { useAppSelector, useAppDispatch } from "../../app/hooks";
import './Timesheet.css';
import '../../common/css/timeLive.css';
import { getCustomFieldTemplateAsync, getTimeEntriesByPeriodIdAsync, getTimesheetPeriodAsync, updateIsLoading, updateValuesFromGlobalState, getTimer, getEmployeeAsync, updateTimesheetOff } from "./timesheetSlice";
import TimesheetTableContainer from "./TimesheetTableContainer";
import TimesheetNavBar from "./TimesheetNavBar";
import ShowError from "./ShowError";
import { ShowToast } from '../../common/Toastr';
import Loader from "../../common/Loader";
import TimesheetPrintViewWidget from "./TimesheetPrintViewWidget";
import TimesheetAttachment from "./TimesheetAttachment";
import TimeSheetApprovalDetails from "./TimesheetApprovalDetails";
import { getCustomPagePermissionsAsync } from "../../common/GlobalSlice";

export function Timesheet() {
    const { sessionAccountEmployeeId } = useAppSelector((state) => state.globalState);
    const { isLoading, currentDate, accountEmployeeId, isReload, isCopyTimesheet, timeEntryViewType, oldTimeEntryViewType, decimalTotalHours, timeEntriesList, showScrollButtons } = useAppSelector((state) => state.timesheet);
    const dispatch = useAppDispatch();
    const modelRef = useRef<any>(null);
    const modelAttachmentRef = useRef<any>(null);
    const modelRefSheetApproval = useRef<any>(null);
     const tableScrollRef = useRef<any>(null);

    const scrollLeft = () => {
        tableScrollRef.current?.scrollLeft();
    };

    const scrollRight = () => {
        tableScrollRef.current?.scrollRight();
    };
    useEffect(() => {
    
    if (accountEmployeeId == 0) {
        dispatch(updateValuesFromGlobalState(sessionAccountEmployeeId));
    }
 
    if (accountEmployeeId != 0) {
        if (isCopyTimesheet) {
            if (timeEntryViewType === oldTimeEntryViewType) {
                dispatch(updateIsLoading(true)); 

                dispatch(getTimesheetPeriodAsync())
                    .then((originalPromiseResult) => {
                        dispatch(getTimeEntriesByPeriodIdAsync());
                    })
                    .catch((rejectedValueOrSerializedError) => {
                        dispatch(updateIsLoading(false)); 
                    });
            } else {
                dispatch(updateIsLoading(false));
                ShowToast('Warning', 'The copied period type cannot be matched with the current period!', "warning", "toast-top-right");
            }
        } else {
            
            dispatch(updateIsLoading(true)); 

            dispatch(getTimesheetPeriodAsync())
                .then((originalPromiseResult) => {
                    dispatch(getTimeEntriesByPeriodIdAsync());
                    dispatch(getCustomFieldTemplateAsync());
                })
                .catch((rejectedValueOrSerializedError) => {
                    dispatch(updateIsLoading(false)); 
                });
        }
    }
}, [currentDate, accountEmployeeId, isReload, dispatch, isCopyTimesheet, timeEntryViewType, oldTimeEntryViewType, sessionAccountEmployeeId]); 


    // useEffect(() => {
    //     accountEmployeeId == 0 && dispatch(updateValuesFromGlobalState(sessionAccountEmployeeId))
    //     if (accountEmployeeId != 0) {
    //         if (isCopyTimesheet) {
    //             if (timeEntryViewType === oldTimeEntryViewType) {
    //                 dispatch(getTimesheetPeriodAsync())
    //                     .then((originalPromiseResult) => {
    //                         // dispatch(getTimer());
    //                         dispatch(getTimeEntriesByPeriodIdAsync());
    //                     })
    //                     .catch((rejectedValueOrSerializedError) => {
    //                     });
    //             } else {
    //                 dispatch(updateIsLoading(false));
    //                 ShowToast('Warning', 'The copied period type cannot be matched with the current period!', "warning", "toast-top-right");
    //             }
    //         } else {
    //             dispatch(getTimesheetPeriodAsync())
    //                 //.unwrap()
    //                 .then((originalPromiseResult) => {
    //                     // dispatch(getTimer());
    //                     dispatch(getTimeEntriesByPeriodIdAsync());
    //                     //dispatch(getEmployeeAsync());
    //                     dispatch(getCustomFieldTemplateAsync());
    //                 })
    //                 .catch((rejectedValueOrSerializedError) => {
    //                 });
    //         }
    //     }
    // }, [currentDate, accountEmployeeId, isReload]);

    useLayoutEffect(() => {
        dispatch(getCustomPagePermissionsAsync("142")).then((res) => {
            if (res.meta.requestStatus === 'fulfilled') {
                let permissions = res.payload;
                dispatch(updateTimesheetOff(getPermission(142, permissions)));
            }
        }).catch()
    }, []);

    function getPermission(id: any, permissions: any) {
        const permission = permissions.find((x: any) => x.Id === id);
        return permission ? permission.IsList : false;
    }

    return (
        <>
            {isLoading && <Loader />}
            {!isLoading &&
                <>
                    <TimesheetNavBar />
                    {showScrollButtons && (
                        <div className="d-flex justify-content-end gap-1" style={{ marginRight: "10px" }}>
                            <button
                                onClick={scrollLeft}
                                className="bg-white"
                                title="Scroll Left"
                            >
                                <i className="ki-outline ki-left text-primaryTL fs-3 scrollBtn"></i>
                            </button>
                            <button
                                onClick={scrollRight}
                                className="bg-white"
                                title="Scroll Right"
                            >
                                <i className="ki-outline ki-right text-primaryTL fs-3 scrollBtn"></i>
                            </button>
                        </div>
                    )}
                    <div className="col-xl-12 mb-12 mb-xl-12">
                        <div className="card card-flush h-xl-100 cardShadow">
                            <div className="card-body pt-8">
                                <ShowError />
                                <div id="TimeEntryPage" className="tab-content">
                                    <TimesheetTableContainer ref={tableScrollRef}/>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            }
            {decimalTotalHours > 0 && <><TimesheetPrintViewWidget modelRef={modelRef} />
                <TimesheetAttachment modelRef={modelAttachmentRef} />
            </>}
            {decimalTotalHours > 0 && <><TimeSheetApprovalDetails modelRef={modelRefSheetApproval} /></>}
        </>
    )
}